import axios from "axios";
import { studioAnalysisData } from '../../_constants/api.constant'
import {getSelfToken} from '../../../_helpers/auth/secureToken'
export async function getStudioAnalyticsData() {
    const response = await axios.get(
        studioAnalysisData.GET,
        {
            headers: {
                Authorization: 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        // handle error
        console.log(error);
        console.log(error.response);
        return error.response;
    });
    return response;
}